import React, { useState, useEffect } from "react";
import HubbleSplashScreen from "./HubbbleSplashScreen";
import HubblePageContainer from "./components/HubblePageContainer";
import HubbleDashboardMenu from "./components/HubbleDashboardMenu";
import HubbleContactMenu from "./components/HubbleContactMenu";
import HubbleButton from "./components/HubbleButton";
import classes from './styles/style.module.css'
import { motion } from 'framer-motion';
import HubbleMediaSlider from "./components/HubbleMediaSlider";
import { useNavigate } from "react-router";

const HubbleDashBoard = () => {
    const [showpreloader, setShowpreloader] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            setShowpreloader(false);
        }, 3000);
    }, []);

    return (
        showpreloader ? <HubbleSplashScreen />
            : (
                <HubblePageContainer>
                    <div className={classes.imageContainer}>
                        <motion.img
                            initial={{ opacity: 0, y: -80 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.7 }}
                            src="images/hubble/hubbleLogo.png" alt="hubble-logo" />
                    </div>
                    <HubbleMediaSlider />
                    <HubbleDashboardMenu />
                    <HubbleButton style={{ marginBlock: '35px' }} onClick={()=>navigate("/hubble/map")} >
                        <div className="d-flex align-items-center justify-content-center">
                            <img src="/images/hubble/icons/right Icon.svg" alt="stop watch" />
                            <span className="mr-3">شروع چالش</span>
                        </div>
                    </HubbleButton>
                    <HubbleContactMenu />
                </HubblePageContainer>
            )
    );
};

export default HubbleDashBoard;
